import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress,
    Alert
} from "@mui/material";
import { useState, useEffect } from "react";
import { getRegistrosContabilidad, getRegistrosEvento, getTrabajadoresUsuario } from "../../services/apis";

export const RegistroAccionesContabilidadDialog = ({ open, setOpen, idEvento }) => {
    const [acciones, setAcciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    console.log(idEvento);
    
    useEffect(() => {

        fetchAcciones();

    }, []);

    const fetchAcciones = async () => {
        setLoading(true);
        setError("");
        try {
            const data = await getRegistrosContabilidad(idEvento);
            setAcciones(data.data || []);
        } catch (err) {
            console.error(err);
            setError("Error en carregar les accions.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
            <DialogTitle>Registre d'accions</DialogTitle>
            <DialogContent dividers>
                {loading ? (
                    <Stack alignItems="center" justifyContent="center" p={3}>
                        <CircularProgress />
                    </Stack>
                ) : error ? (
                    <Alert severity="error">{error}</Alert>
                ) : acciones.length === 0 ? (
                    <Typography variant="body1">
                        No hi ha accions registrades per a aquest apartat.
                    </Typography>
                ) : (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Acció</TableCell>
                                <TableCell>Data</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {acciones.map((accion) => (
                                <TableRow key={accion.id}>
                                    <TableCell>{accion.accion}</TableCell>
                                    <TableCell>{new Date(accion.fecha).toLocaleString("ca-ES")}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)} color="primary">
                    Tancar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
